import UnauthenticatedError from './UnauthenticatedException'

export default class RevokedCredentialsException extends UnauthenticatedError {
}
